import React from "react";
import { Briefcase, Calendar, MapPin } from "lucide-react";
import "../styles/Experience.css";

const experiences = [
  {
    title: "Technical Intern",
    company: "McLaren Strategic Solutions",
    period: "July - September 2025",
    location: "Remote",
    description: "Worked on projects including legacy modernization, migrating Sybase stored procedures to PostgreSQL, improving database performance and system compatibility.",
    skills: ["PostgreSQL", "Database Migration", "Legacy Systems"],
  },
  {
    title: "AI Intern",
    company: "Lenovo Leap",
    period: "June - August 2025",
    location: "Remote",
    description: "Worked in AI field with key learnings including deep learning, model training, Botpress chatbot development, and automation solutions.",
    skills: ["Deep Learning", "Botpress", "Automation"],
  },
  {
    title: "Cybersecurity Virtual Internship",
    company: "Eduskills",
    period: "July - September 2025",
    location: "Virtual",
    description: "Gained hands-on experience in basics of cybersecurity, including threat analysis, security protocols, and vulnerability assessment.",
    skills: ["Cybersecurity", "Threat Analysis", "Security Protocols"],
  },
  {
    title: "Google Cloud Study Jams",
    company: "GDSC PCC",
    period: "2024",
    location: "Goa",
    description: "Built expertise in Google Cloud Platform (GCP), learning cloud computing concepts, services deployment, and infrastructure management.",
    skills: ["GCP", "Cloud Computing", "Infrastructure"],
  },
];

const Experience = () => {
  return (
    <section className="experience">
      <div className="experience-header">
        <p className="experience-label">Career Journey</p>
        <h2>Experience</h2>
        <p className="experience-subtitle">
          Building expertise through diverse roles in software development, AI, and cloud computing.
        </p>
      </div>

      <div className="experience-timeline">
        {experiences.map((exp, index) => (
          <div className="experience-card" key={index}>
            <div className="experience-card-marker">
              <div className="marker-dot" />
              {index < experiences.length - 1 && <div className="marker-line" />}
            </div>
            <div className="experience-card-content">
              <div className="experience-card-header">
                <div>
                  <h3>{exp.title}</h3>
                  <p className="experience-company">
                    <Briefcase size={14} /> {exp.company}
                  </p>
                </div>
                <div className="experience-meta">
                  <span><Calendar size={13} /> {exp.period}</span>
                  <span><MapPin size={13} /> {exp.location}</span>
                </div>
              </div>
              <p className="experience-desc">{exp.description}</p>
              <div className="experience-skills">
                {exp.skills.map((skill, idx) => (
                  <span key={idx} className="experience-skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
